import { PortfolioList } from "@/components/sections/PortfolioList/PortfolioList";

export const PortfolioPage = () => {
  return <PortfolioList />;
};
